module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 0